import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_900, Button, Collapsible, Callout, Divider, getTestId, isValidObject, LILAC_400, tokens, WHITE, KeyPairUnit } from '@airtel/air-design-system';
import { useCallback, useEffect, useRef, useState } from 'react';
import { FlatList, View } from 'react-native';
import { CardTitleWidgetComponent } from '../card-title-widget/CardTitleWidget';
import { OfferListWidget } from '../offer-list-widget';
import { OfferContextualStripWidget } from '../offer-contextual-strip-widget';
import { PayCategoryCardWidget } from '../pay-category-card-widget';
import { getCollapsibleOfferListWidgetStyles } from './CollapsibleOfferListWidgetStyles';
export var CollapsibleOfferListWidgetComponent = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'CollapsibleOfferListWidget' : _props$testID,
    data = props.data,
    style = props.style,
    _props$viewMoreButton = props.viewMoreButtonProps,
    viewMoreButtonProps = _props$viewMoreButton === void 0 ? {} : _props$viewMoreButton,
    onUserAction = props.onUserAction,
    resetToggleIndexMetaData = props.resetToggleIndexMetaData,
    _props$expandItems = props.expandItems,
    expandItems = _props$expandItems === void 0 ? false : _props$expandItems,
    _props$maxItemsToShow = props.maxItemsToShow,
    maxItemsToShow = _props$maxItemsToShow === void 0 ? 0 : _props$maxItemsToShow,
    _props$toggleItemInde = props.toggleItemIndex,
    toggleItemIndex = _props$toggleItemInde === void 0 ? 0 : _props$toggleItemInde,
    _props$expandedItemIn = props.expandedItemIndex,
    expandedItemIndex = _props$expandedItemIn === void 0 ? -1 : _props$expandedItemIn,
    _props$selectedPaymod = props.selectedPaymodeIndex,
    selectedPaymodeIndex = _props$selectedPaymod === void 0 ? -1 : _props$selectedPaymod,
    resetPayCategoryCardData = props.resetPayCategoryCardData;
  var _useState = useState(-1),
    prevExpandedItemIndex = _useState[0],
    setPrevExpandedItemIndex = _useState[1];
  var _useState2 = useState(-1),
    prevSelectedPaymodeIndex = _useState2[0],
    setPrevSelectedPaymodeIndex = _useState2[1];
  var collapsibleOfferListWidgetStyles = getCollapsibleOfferListWidgetStyles();
  var setOfVisitedIds = useRef(new Set());
  var collapsibleRef = useRef({});
  var _useState3 = useState(undefined),
    list = _useState3[0],
    setList = _useState3[1];
  var _useState4 = useState(false),
    isVisible = _useState4[0],
    setIsVisible = _useState4[1];
  var viewMoreButtonTitle = isVisible ? viewMoreButtonProps.expandedTitle : viewMoreButtonProps.title;
  var toggleAndCollapseItems = (selectedIndex, toggleIndexChanged) => {
    var _a, _b, _c, _d, _e;
    if (!list || (list === null || list === void 0 ? void 0 : list.length) == 0) {
      return;
    }
    if (!((_a = list[selectedIndex]) === null || _a === void 0 ? void 0 : _a.shouldCollapse)) {
      (_c = (_b = collapsibleRef.current) === null || _b === void 0 ? void 0 : _b[selectedIndex]) === null || _c === void 0 ? void 0 : _c.toggle((_d = list[selectedIndex]) === null || _d === void 0 ? void 0 : _d.isExpanded);
      return;
    }
    if (toggleIndexChanged && ((_e = list === null || list === void 0 ? void 0 : list[selectedIndex]) === null || _e === void 0 ? void 0 : _e.isExpanded) === true) {
      return;
    }
    resetPayCategoryCardData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, resetPayCategoryCardData)));
    var updatedList = list.map((item, index) => {
      var _a, _b, _c, _d, _e;
      if (item === null || item === void 0 ? void 0 : item.shouldCollapse) {
        item.isExpanded = selectedIndex === index ? !item.isExpanded : false;
      }
      (_c = (_b = (_a = item === null || item === void 0 ? void 0 : item.content) === null || _a === void 0 ? void 0 : _a.offerListWidget) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.forEach(dataItem => {
        if (dataItem === null || dataItem === void 0 ? void 0 : dataItem.selectionListProps) {
          dataItem.selectionListProps.isSelected = false;
          dataItem.selectionListProps.otpProps = {};
        }
      });
      (_e = (_d = collapsibleRef.current) === null || _d === void 0 ? void 0 : _d[index]) === null || _e === void 0 ? void 0 : _e.toggle(item.isExpanded);
      return item;
    });
    setList(updatedList);
    resetToggleIndexMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, resetToggleIndexMetaData), Object.assign({}, props)));
  };
  useEffect(() => {
    transformDataWithMaxItemsToShow(data);
    if (isVisible) {
      data.map((item, index) => {
        if (index >= maxItemsToShow) item.isExpanded = false;
      });
    }
  }, [isVisible]);
  useEffect(() => {
    transformDataWithMaxItemsToShow(data);
  }, [data]);
  useEffect(() => {
    setIsVisible(expandItems);
  }, [expandItems]);
  var transformDataWithMaxItemsToShow = listData => {
    if (listData) {
      var newData = [...listData];
      if (!isVisible && maxItemsToShow > 0) {
        newData.splice(maxItemsToShow);
      }
      newData.forEach((item, index) => {
        var _a, _b;
        (_b = (_a = collapsibleRef.current) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.toggle(item.isExpanded);
      });
      setList(newData);
    }
  };
  useEffect(() => {
    if (toggleItemIndex >= 0) toggleAndCollapseItems(toggleItemIndex, true);
  }, [toggleItemIndex]);
  var handleSelection = (outerIdx, innerIdx) => {
    var _a, _b, _c, _d;
    var prevOfferListWidget = (_b = (_a = data[prevExpandedItemIndex]) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.offerListWidget;
    var currentOfferListWidget = (_d = (_c = data[outerIdx]) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.offerListWidget;
    if (prevOfferListWidget && prevSelectedPaymodeIndex !== -1) {
      var prevSelection = prevOfferListWidget.data[prevSelectedPaymodeIndex].selectionListProps;
      prevSelection.isSelected = false;
      prevSelection.otpProps = {};
    }
    resetPayCategoryCardData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, resetPayCategoryCardData)));
    if (currentOfferListWidget) {
      currentOfferListWidget.data[innerIdx].selectionListProps.isSelected = true;
    }
    data.forEach((item, index) => {
      if (item.shouldCollapse) {
        if (item.isExpanded && index != outerIdx) {
          item.isExpanded = !item.isExpanded;
        }
      }
    });
    setPrevExpandedItemIndex(outerIdx);
    setPrevSelectedPaymodeIndex(innerIdx);
    transformDataWithMaxItemsToShow(data);
  };
  useEffect(() => {
    expandedItemIndex > -1 && selectedPaymodeIndex > -1 && handleSelection(expandedItemIndex, selectedPaymodeIndex);
  }, [expandedItemIndex, selectedPaymodeIndex]);
  var onCalloutCtaPress = onCtaPress => {
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, onCtaPress), props);
  };
  var isPreviousItemExpanded = index => {
    var _a;
    return index >= 1 && ((_a = list[index - 1]) === null || _a === void 0 ? void 0 : _a.isExpanded);
  };
  var isNextItemExpanded = index => {
    var _a;
    return index + 1 <= list.length - 1 && ((_a = list[index + 1]) === null || _a === void 0 ? void 0 : _a.isExpanded);
  };
  var showDivider = index => {
    var _a;
    return index !== list.length - 1 && !((_a = list[index + 1]) === null || _a === void 0 ? void 0 : _a.isExpanded);
  };
  var _renderItem = (item, index) => {
    var _a, _b;
    var isFirstItem = index === 0;
    var isLastItem = index === list.length - 1;
    var isPreviousExpanded = isPreviousItemExpanded(index);
    var isNextExpanded = isNextItemExpanded(index);
    var isCurrentItemExpanded = item === null || item === void 0 ? void 0 : item.isExpanded;
    var itemContent = (item === null || item === void 0 ? void 0 : item.content) || {};
    var offerListWidget = (itemContent === null || itemContent === void 0 ? void 0 : itemContent.offerListWidget) || {};
    var payCategoryCardWidget = (itemContent === null || itemContent === void 0 ? void 0 : itemContent.payCategoryCardWidget) || {};
    var keyPairUnitWidget = (itemContent === null || itemContent === void 0 ? void 0 : itemContent.keyPairUnitWidget) || {};
    var titleColor = (_a = item === null || item === void 0 ? void 0 : item.titleColor) !== null && _a !== void 0 ? _a : BLACK_900;
    var calculateCurrentCardStyle = () => {
      var cardStyle = {};
      if (isFirstItem || isPreviousExpanded) {
        cardStyle = Object.assign({}, collapsibleOfferListWidgetStyles.topBorderRadius);
      }
      if (isLastItem || isNextExpanded && !isCurrentItemExpanded) {
        cardStyle = Object.assign(Object.assign({
          borderBottomWidth: tokens.spacing.SPACING_1
        }, cardStyle), collapsibleOfferListWidgetStyles.bottomBorderRadius);
      } else if (isNextExpanded) {
        cardStyle = Object.assign(Object.assign({}, cardStyle), collapsibleOfferListWidgetStyles.bottomBorderRadius);
      }
      if (isCurrentItemExpanded) {
        cardStyle = Object.assign(Object.assign(Object.assign({}, collapsibleOfferListWidgetStyles.topBorderRadius), {
          paddingBottom: tokens.spacing.SPACING_0
        }), collapsibleOfferListWidgetStyles.bottomBorderRadius);
      }
      return cardStyle;
    };
    var calculateWidgetMargin = () => {
      var widgetMargin = {};
      if (isPreviousExpanded && !isCurrentItemExpanded) {
        widgetMargin = {
          marginTop: tokens.spacing.SPACING_16
        };
      }
      if (isNextExpanded) {
        widgetMargin = Object.assign(Object.assign({}, widgetMargin), {
          marginBottom: tokens.spacing.SPACING_16
        });
      }
      return widgetMargin;
    };
    var wrapperProps = {
      showShadow: false,
      noPadding: true,
      noHorizontalPadding: true,
      noVerticalPadding: true,
      withRoundedBorder: false,
      style: Object.assign(Object.assign({}, collapsibleOfferListWidgetStyles.cardTitle), calculateCurrentCardStyle())
    };
    return _jsxs(View, Object.assign({
      style: calculateWidgetMargin()
    }, {
      children: [_jsx(Collapsible, Object.assign({
        id: item.id,
        ref: refState => collapsibleRef.current[index] = refState,
        iconName: "DownChevronButtonIcon",
        iconSize: "xl",
        disabled: !(item === null || item === void 0 ? void 0 : item.shouldCollapse),
        showIcon: item === null || item === void 0 ? void 0 : item.shouldCollapse,
        initialOpen: isCurrentItemExpanded,
        childNoVerticalPadding: true,
        titleNoVerticalPadding: true,
        childNoHorizontalPadding: true,
        onPress: () => {
          item.collapsibleTitleOnPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, item.collapsibleTitleOnPressMetaData), Object.assign(Object.assign({}, props), {
            sectionName: item === null || item === void 0 ? void 0 : item.title,
            itemExpandedOrCollapsed: (item === null || item === void 0 ? void 0 : item.isExpanded) ? 'Collapsed' : 'Expanded'
          })));
          toggleAndCollapseItems(index, false);
        },
        withCard: true,
        cardWrapperProps: wrapperProps,
        collapsibleWrapperStyles: wrapperProps === null || wrapperProps === void 0 ? void 0 : wrapperProps.style
      }, (item === null || item === void 0 ? void 0 : item.isExpanded) ? item === null || item === void 0 ? void 0 : item.collapsedStateAccessibilityProps : item === null || item === void 0 ? void 0 : item.expandedStateAccessibilityProps, {
        titleComponent: _jsx(CardTitleWidgetComponent, Object.assign({
          title: item === null || item === void 0 ? void 0 : item.title,
          imageProps: item === null || item === void 0 ? void 0 : item.imageProps,
          iconName: item === null || item === void 0 ? void 0 : item.iconName,
          color: titleColor,
          onUserAction: onUserAction,
          style: collapsibleOfferListWidgetStyles.collapsibleTitle
        }, getTestId(testID, 'CardTitle'))),
        subTitleComponent: _jsxs(View, {
          children: [((_b = item === null || item === void 0 ? void 0 : item.calloutProps) === null || _b === void 0 ? void 0 : _b.length) > 0 && (item === null || item === void 0 ? void 0 : item.calloutProps.map(calloutProp => {
            return _jsx(_Fragment, {
              children: Object.keys(calloutProp).length > 0 && _jsx(Callout, Object.assign({
                style: collapsibleOfferListWidgetStyles.callout,
                onCtaPress: () => onCalloutCtaPress(item === null || item === void 0 ? void 0 : item.calloutPropsCtaMetaData)
              }, getTestId(testID, 'callout'), calloutProp))
            });
          })), isValidObject(item === null || item === void 0 ? void 0 : item.offerStripProps) && _jsx(OfferContextualStripWidget, Object.assign({}, item === null || item === void 0 ? void 0 : item.offerStripProps, {
            style: collapsibleOfferListWidgetStyles.callout
          }, getTestId(testID, 'offerStrip'), {
            onUserAction: onUserAction
          }))]
        })
      }, {
        children: isValidObject(offerListWidget) && _jsx(OfferListWidget, Object.assign({}, offerListWidget, {
          showShadow: false,
          style: collapsibleOfferListWidgetStyles.offerListWidget,
          onUserAction: onUserAction,
          isCurrentItemVisible: isCurrentItemExpanded
        }, getTestId(testID, 'OfferList'))) || isValidObject(payCategoryCardWidget) && _jsx(PayCategoryCardWidget, Object.assign({}, payCategoryCardWidget, {
          style: [collapsibleOfferListWidgetStyles.offerListWidget, Object.assign({}, collapsibleOfferListWidgetStyles.payCategoryCardWidget)],
          isCurrentItemVisible: isCurrentItemExpanded,
          onUserAction: onUserAction
        }, getTestId(testID, 'PayCategoryCardWidget'))) || isValidObject(keyPairUnitWidget) && _jsx(KeyPairUnit, Object.assign({}, keyPairUnitWidget, {
          style: [collapsibleOfferListWidgetStyles.offerListWidget, collapsibleOfferListWidgetStyles.keyPairUnit]
        }, getTestId(testID, 'KeyPairUnit')))
      })), !isCurrentItemExpanded && showDivider(index) ? _jsx(Divider, {
        color: LILAC_400,
        height: 2,
        shadowColor: WHITE,
        style: collapsibleOfferListWidgetStyles.dividerStyle
      }) : null]
    }));
  };
  var onViewableItemsChanged = useCallback(info => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var _loop = function _loop(i) {
      var sendImpression = !((_b = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _b === void 0 ? void 0 : _b.has((_c = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _c === void 0 ? void 0 : _c.index));
      if (sendImpression && ((_e = (_d = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _d === void 0 ? void 0 : _d[i]) === null || _e === void 0 ? void 0 : _e.index) != null) {
        (_f = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _f === void 0 ? void 0 : _f.add((_g = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _g === void 0 ? void 0 : _g.index);
        (_k = (_j = (_h = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _h === void 0 ? void 0 : _h[i].item) === null || _j === void 0 ? void 0 : _j.onItemsImpressionMetaData) === null || _k === void 0 ? void 0 : _k.map(data => {
          var _a;
          onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, data), (_a = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _a === void 0 ? void 0 : _a.item);
        });
      }
    };
    for (var i = 0; i < ((_a = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _a === void 0 ? void 0 : _a.length); i++) {
      _loop(i);
    }
  }, []);
  return _jsxs(View, Object.assign({}, getTestId(testID), {
    style: [style]
  }, {
    children: [_jsx(FlatList, Object.assign({
      data: list,
      keyExtractor: item => item.id,
      onViewableItemsChanged: onViewableItemsChanged,
      renderItem: _ref => {
        var item = _ref.item,
          index = _ref.index;
        return _renderItem(item, index);
      }
    }, getTestId(testID, 'FlatList'))), isValidObject(viewMoreButtonProps) && _jsx(View, Object.assign({
      style: collapsibleOfferListWidgetStyles.expandSection
    }, {
      children: _jsx(Button, Object.assign({
        title: viewMoreButtonTitle,
        onPress: () => {
          setIsVisible(!isVisible);
          viewMoreButtonProps.onPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, viewMoreButtonProps.onPressMetaData), Object.assign(Object.assign({}, props), {
            buttonTitle: viewMoreButtonTitle
          })));
        },
        iconPosition: "right",
        iconName: isVisible ? viewMoreButtonProps.expandedIconName : viewMoreButtonProps.iconName,
        buttonType: "tertiary",
        version: "variable-width"
      }, getTestId(testID, 'button'), {
        style: collapsibleOfferListWidgetStyles.expandCta,
        isUpperCase: viewMoreButtonProps.isUpperCase,
        size: "md"
      }, viewMoreButtonProps === null || viewMoreButtonProps === void 0 ? void 0 : viewMoreButtonProps.accessibilityProps))
    }))]
  }));
};
CollapsibleOfferListWidgetComponent.genericRendererKey = 'AirCollapsibleOfferListWidget';